<div class="min-h-screen bg-gray-50">
  <app-navbar [showBackButton]="true"></app-navbar>

  <!-- Hero Section -->
  <div class="relative bg-gradient-to-br from-slate-800 via-slate-700 to-slate-600 text-white overflow-hidden">
    <div class="absolute inset-0 opacity-20">
      <img
        src="university-students-graduating-ceremony-profession.jpg"
        alt="Background"
        class="w-full h-full object-cover"
      />
    </div>
    <div class="relative max-w-7xl mx-auto px-4 py-12">
      <div class="flex items-center gap-4">
        <div class="w-16 h-16 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/20 relative">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
          <div *ngIf="naoLidas > 0" class="absolute -top-1 -right-1 w-7 h-7 bg-red-500 rounded-full flex items-center justify-center border-2 border-white">
            <span class="text-xs font-bold text-white">{{ naoLidas }}</span>
          </div>
        </div>
        <div>
          <h1 class="text-3xl font-bold mb-1">Central de Notificações</h1>
          <p class="text-white/80">
            Acompanhe todas as atualizações sobre seus processos seletivos
            <span *ngIf="naoLidas > 0" class="ml-2 text-white font-semibold">
              • {{ naoLidas }} não lida{{ naoLidas > 1 ? 's' : '' }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="max-w-4xl mx-auto px-4 py-8">
    <!-- Alert de notificações não lidas -->
    <div *ngIf="naoLidas > 0" class="bg-white rounded-lg border border-gray-200 p-4 mb-6 flex items-center justify-between shadow-sm">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-[#4A90E2]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <p class="text-sm text-gray-700">
          Você tem <strong class="text-gray-900">{{ naoLidas }}</strong> notificação{{ naoLidas > 1 ? 'ões' : '' }} não lida{{ naoLidas > 1 ? 's' : '' }}
        </p>
      </div>
      <button
        (click)="marcarTodasComoLidas()"
        class="px-4 py-2 text-sm border border-[#4A90E2] text-[#4A90E2] rounded-lg hover:bg-blue-50 transition-colors bg-transparent font-medium"
      >
        Marcar todas como lidas
      </button>
    </div>

    <!-- Lista de Notificações -->
    <div class="space-y-4">
      <ng-container *ngFor="let notif of notificacoes; let i = index">
        <div>
          <a [routerLink]="notif.link">
            <div
              class="bg-white rounded-lg border-l-4 hover:shadow-lg transition-all p-5"
              [ngClass]="[
                notif.corBorda,
                !notif.lida ? 'shadow-md border-r border-t border-b border-gray-200' : 'border border-gray-200'
              ]"
            >
              <div class="flex gap-4">
                <!-- Ícone -->
                <div class="w-12 h-12 rounded-full flex items-center justify-center shrink-0" [ngClass]="notif.corFundo">
                  <!-- Check Circle -->
                  <svg *ngIf="getIcone(notif.tipo) === 'check-circle'" class="w-6 h-6" [ngClass]="notif.cor" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <!-- Alert Circle -->
                  <svg *ngIf="getIcone(notif.tipo) === 'alert-circle'" class="w-6 h-6" [ngClass]="notif.cor" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <!-- Info -->
                  <svg *ngIf="getIcone(notif.tipo) === 'info'" class="w-6 h-6" [ngClass]="notif.cor" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <!-- File Text -->
                  <svg *ngIf="getIcone(notif.tipo) === 'file-text'" class="w-6 h-6" [ngClass]="notif.cor" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <!-- Calendar -->
                  <svg *ngIf="getIcone(notif.tipo) === 'calendar'" class="w-6 h-6" [ngClass]="notif.cor" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>

                <!-- Conteúdo -->
                <div class="flex-1 min-w-0">
                  <div class="flex items-start justify-between gap-3 mb-2">
                    <div class="flex items-center gap-2 flex-wrap">
                      <h3 class="font-bold text-gray-900 text-lg">{{ notif.titulo }}</h3>
                      <span *ngIf="!notif.lida" class="bg-red-500 text-white text-xs px-2 py-0.5 rounded">Novo</span>
                    </div>
                    <div class="flex items-center gap-2 text-sm text-gray-500 shrink-0">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span class="whitespace-nowrap">{{ notif.data }}</span>
                      <span>•</span>
                      <span class="whitespace-nowrap">{{ notif.hora }}</span>
                    </div>
                  </div>

                  <p class="text-gray-700 leading-relaxed mb-3">{{ notif.mensagem }}</p>

                  <div class="flex items-center justify-between">
                    <span class="text-sm font-medium" [ngClass]="notif.cor">Ver detalhes →</span>
                    <button
                      *ngIf="!notif.lida"
                      (click)="marcarComoLida(notif, $event)"
                      class="px-3 py-1 text-gray-500 hover:text-gray-700 text-xs hover:bg-gray-100 rounded transition-colors"
                    >
                      Marcar como lida
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </a>

          <!-- Separador entre não lidas e lidas -->
          <div *ngIf="mostrarSeparador(i)" class="py-4">
            <div class="flex items-center gap-3">
              <div class="flex-1 h-px bg-gray-300"></div>
              <span class="text-sm text-gray-500 font-medium">Notificações Anteriores</span>
              <div class="flex-1 h-px bg-gray-300"></div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Empty State -->
    <div *ngIf="notificacoes.length === 0" class="bg-white rounded-lg border border-gray-200 p-12 text-center">
      <div class="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>
      </div>
      <h3 class="text-xl font-bold text-gray-900 mb-2">Nenhuma notificação</h3>
      <p class="text-gray-600">Você não possui notificações no momento.</p>
    </div>

    <!-- Info Box -->
    <div class="mt-8 bg-blue-50 border-l-4 border-blue-600 rounded-r-lg p-5 shadow-sm">
      <div class="flex gap-3">
        <svg class="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <div>
          <h3 class="font-bold text-blue-900 mb-2">Sobre as Notificações</h3>
          <p class="text-sm text-blue-800 leading-relaxed">
            Todas as atualizações importantes sobre seus processos seletivos serão exibidas aqui. Você também
            receberá e-mails com as notificações mais relevantes. Recomendamos verificar regularmente esta central
            para não perder nenhuma informação importante.
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
<app-footer></app-footer>
</div>
